import styled, { css } from 'styled-components';

import { Dropdown } from 'Elements/Input/Dropdown/Dropdown.styled';

import { Tick } from '@solent-university/solent-icons';

export const Wrapper = styled.div`
    position: relative;
    line-height: initial;
`;

export const Label = styled.label<{ $checked: boolean; $disabled: boolean }>`
    ${({ theme, $checked, $disabled }) => css`
        position: relative;
        font-size: 1.125rem;

        ${Dropdown} & {
            font-size: 1rem;
        }

        line-height: initial;
        padding-left: 2.25rem;
        margin-left: 0.25rem;
        display: inline-block;
        font-weight: 300;

        &:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 1.1rem;
            height: 1.1rem;
            border: 0.1rem solid ${theme.colors.primary.hex};
            border-radius: 0.25rem;
            background: ${theme.colors.background.hex};

            ${$checked &&
            !$disabled &&
            css`
                background-color: ${theme.colors.primary.hex};
            `}

            ${$checked &&
            $disabled &&
            css`
                background-color: ${theme.colors.secondary.tints[1].hex};
            `}

            ${$disabled &&
            css`
                border-color: ${theme.colors.secondary.tints[1].hex};
            `}
        }

        ${!$disabled &&
        css`
            &:hover {
                cursor: pointer;

                &:before {
                    box-shadow: 0 0 0 0.25rem ${theme.colors.primary.hex}33,
                        inset 0 0 0 1.25rem ${theme.colors.primary.hex}33;
                }
            }
        `}
    `}
`;

export const HiddenCheckbox = styled.input`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 1.1rem;
        height: 1.1rem;

        &:focus + ${Label} {
            &:before {
                box-shadow: 0 0 0 0.25rem ${theme.colors.primary.hex}33,
                    inset 0 0 0 1.25rem ${theme.colors.primary.hex}33;
            }
        }
    `}
`;

export const StyledTick = styled(Tick)<{ $checked: boolean }>`
    ${({ theme, $checked }) => css`
        position: absolute;
        top: 50%;
        left: 0.15rem;
        transform: translateY(-50%);
        color: ${theme.colors.secondary.hex};
        height: 1rem;
        width: 1rem;
        stroke-width: 0.15rem;
        z-index: 1;

        ${$checked
            ? css`
                  display: block;
              `
            : css`
                  display: none;
              `}
    `}
`;
